import { List } from "./List";
import { Detail } from "./Detail";
import { Board } from "./Board";
import { Statistics } from "./Statistics";
import { AdminLoginStats } from "./AdminLoginStats";

export default { List, Detail, Board, Statistics, AdminLoginStats };
